import { InputField } from "@rawa/ui/InputField"
import { fieldInstructions, fieldName } from "../fields"
import type { ControlRenderer } from "./types"

// The value is the text as typed, or none once it is emptied.
export const singleLineText: ControlRenderer<"singleLineText"> = {
  Render: ({ field, value, onChange, readOnly, error }) => (
    <InputField
      id={field.id}
      label={fieldName(field)}
      hint={fieldInstructions(field)}
      value={value ?? ""}
      onChange={(text) => onChange(text === "" ? undefined : text)}
      placeholder={field.placeholder}
      required={field.required}
      readOnly={readOnly}
      error={error}
    />
  ),
}
